/*!
 * angular-ui-uploader
 * https://github.com/angular-ui/ui-uploader
 * Version: 1.1.2 - 2015-10-27T03:09:52.784Z
 * License: MIT
 */

import { isFunction } from 'lodash';

/*
 * Author: Remy Alain Ticona Carbajal http://realtica.org
 * Description: The main objective of ng-uploader is to have a user control,
 * clean, simple, customizable, and above all very easy to implement.
 * Licence: MIT
 */

export class UiUploader {
  constructor() {
    this.files = [];
    this.fileKeyMap = []; //index match with this.files
    this.options = {};
    this.activeUploads = 0;
    this.uploadedFiles = 0;
  }

  addFiles(files, key = null) {
    for (var i = 0; i < files.length; i++) {
      this.fileKeyMap[this.files.length] = key || this.options?.key;
      this.files.push(files[i]);
    }
  }

  getFiles() {
    return this.files;
  }

  startUpload(options) {
    this.options = options;
    let xhrList = [];

    if (this.options.singleRequest) {
      let xhr = this.ajaxUpload(
        this.files,
        this.options.url,
        this.options.data,
        Array.isArray(this.fileKeyMap) && this.fileKeyMap.length
          ? this.fileKeyMap
          : this.options.key
      );
      xhrList.push(xhr);
    } else {
      for (let i = 0; i < this.files.length; i++) {
        if (this.activeUploads == this.options.concurrency) {
          break;
        }
        if (this.files[i].active) continue;
        let xhr = this.ajaxUpload(
          this.files[i],
          this.options.url,
          this.options.data,
          this.fileKeyMap[i] || this.options.key
        );
        xhrList.push(xhr);
      }
    }

    return () => {
      xhrList.forEach((xhr) => {
        xhr.abort();
      });
    };
  }

  removeFile(file) {
    let idx = this.files.indexOf(file);
    this.files.splice(idx, 1);
    this.fileKeyMap.splice(idx, 1);
  }

  removeAll() {
    this.files.splice(0, this.files.length);
    this.fileKeyMap.splice(0, this.fileKeyMap.length);
  }

  getHumanSize(bytes) {
    var sizes = [
      'n/a',
      'bytes',
      'KB',
      'MB',
      'GB',
      'TB',
      'PB',
      'EB',
      'ZB',
      'YB',
    ];
    var i = bytes === 0 ? 0 : +Math.floor(Math.log(bytes) / Math.log(1000));
    return (
      (bytes / Math.pow(1000, i)).toFixed(i ? 1 : 0) +
      ' ' +
      sizes[isNaN(bytes) ? 0 : i + 1]
    );
  }

  ajaxUpload(file, url, data, key) {
    let xhr, formData, prop;
    key = key || 'file';
    data = data || {};

    if (Array.isArray(file)) {
      file.forEach((it) => {
        this.activeUploads += 1;
        it.active = true;
      });
    } else {
      this.activeUploads += 1;
      file.active = true;
    }
    xhr = new window.XMLHttpRequest();

    // To account for sites that may require CORS
    if (data.withCredentials === true) {
      xhr.withCredentials = true;
    }

    formData = new window.FormData();
    xhr.open('POST', url);

    // Triggered when upload starts:
    xhr.upload.onloadstart = () => {};

    // Triggered many times during upload:
    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable) {
        return;
      }
      // Update file size because it might be bigger than reported by
      // the fileSize:
      //$log.info("progres..");
      //console.info(event.loaded);
      let sum = {
        name: [],
        loaded: event.loaded,
        humanSize: this.getHumanSize(event.loaded),
        files: file,
      };

      sum = Array.isArray(file)
        ? file.reduce((acc, cur) => {
            acc.size = acc.size + cur.size;
            acc.name.push(cur.name);
            return acc;
          }, sum)
        : {
            name: file?.name,
            size: file?.size,
            type: file?.type,
            active: file?.active,
            loaded: sum.loaded,
            humanSize: sum.humanSize,
            files: file,
          };

      if (isFunction(this.options.onProgress)) {
        this.options.onProgress(sum);
      }
    };

    // Triggered when upload is completed:
    xhr.onload = () => {
      if (Array.isArray(file)) {
        this.activeUploads -= file.length;
        this.uploadedFiles += file.length;
      } else {
        this.activeUploads -= 1;
        this.uploadedFiles += 1;
      }

      if (!this.options.singleRequest) {
        this.startUpload(this.options);
      }
      if (isFunction(this.options.onCompleted)) {
        this.options.onCompleted(file, xhr.responseText, xhr.status);
      }
      if (this.uploadedFiles === this.files.length) {
        this.uploadedFiles = 0;
        if (isFunction(this.options.onCompletedAll)) {
          this.options.onCompletedAll(this.files);
        }
      }
    };

    // Triggered when upload fails:
    xhr.onerror = (e) => {
      if (isFunction(this.options.onError)) {
        this.options.onError(e);
      }
    };

    // Append additional data if provided:
    if (data) {
      for (prop in data) {
        if (data.hasOwnProperty(prop)) {
          formData.append(prop, data[prop]);
        }
      }
    }

    // Append file data:
    if (Array.isArray(file)) {
      file.forEach((it, idx) => {
        let k = Array.isArray(key) ? key[idx] || key[0] : key;
        formData.append(k, it, it.name);
      });
    } else {
      formData.append(key, file, file.name);
    }

    // Initiate upload:
    xhr.send(formData);

    return xhr;
  }
}
